import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AccommodationProvider } from './contexts/AccommodationContext';
import { ImageProvider } from '@agape/frontend-utils';
import { assetsApi } from './api/client';
import { AttractionsProvider } from './contexts/AttractionsContext';
import { LanguageProvider } from './contexts/LanguageProvider';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import AIAssistant from './components/AIAssistant';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import UsefulInformation from './pages/UsefulInformation';
import LocalArea from './pages/LocalArea';
import Accommodations from './pages/Accommodations';
import { CONTACT_INFO } from './config/constants';

function App() {
  // Set the document title from constants
  useEffect(() => {
    document.title = CONTACT_INFO.GUESTHOUSE_NAME;
  }, []);
  
  // Guesthouse needs both accommodation and attraction photos
  const fetchGuesthousePhotos = async () => {
    const [accommodationPhotos, attractionPhotos] = await Promise.all([
      assetsApi.listAccommodationPhotos(),
      assetsApi.listAttractionPhotos(),
    ]);
    return [...accommodationPhotos, ...attractionPhotos];
  };
  
  return (
    <Router>
      <ScrollToTop />
      <LanguageProvider>
        <AccommodationProvider>
          <ImageProvider fetchPhotos={fetchGuesthousePhotos}>
            <AttractionsProvider>
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/useful-information" element={<UsefulInformation />} />
                  <Route path="/local-area" element={<LocalArea />} />
                  <Route path="/accommodations" element={<Accommodations />} />
                </Routes>
                <AIAssistant />
              </Layout>
            </AttractionsProvider>
          </ImageProvider>
        </AccommodationProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;
